export default __webpack_public_path__ + "static/media/2509.cbe42089.png";